import * as React from "react";
import { cn } from "./utils";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentPropsWithoutRef<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      ref={ref}
      data-slot="textarea"
      className={cn(
        "flex w-full rounded-md",
        "min-h-[6rem]",                  // ✅ correct height
        "resize-y",                      // ✅ allow resize like design
        "border border-gray-200",        // ✅ softer border
        "bg-gray-50 dark:bg-gray-800",   // ✅ design-matching bg
        "px-3 py-2 text-sm",
        "placeholder:text-muted-foreground",
        "outline-none transition",
        "focus-visible:ring-2 focus-visible:ring-blue-500",
        "focus-visible:border-blue-500",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    />
  );
});

Textarea.displayName = "Textarea";

export { Textarea };
